import { all, takeLatest, put, call, select } from 'redux-saga/effects';

import {
  apiFetchRegionDeliveryInfo,
  apiFetchUserLatestDeliveryInfo,
} from '@dragonfruit/services/apis';
import { getRegion } from '@dragonfruit/redux/locale';

import {
  fetchRegionDeliveryInfoSuccess,
  fetchRegionDeliveryInfoFailure,
  fetchUserLatestDeliveryInfoSuccess,
  fetchUserLatestDeliveryInfoFailure,
  FETCH_REGION_DELIVERY_INFO,
  FETCH_USER_LATEST_DELIVERY_INFO,
} from '@dragonfruit/redux/purchase/deliveryInfo';

export function* fetchRegionDeliveryInfoFlow(action) {
  try {
    const appRegion = yield select(getRegion);
    const { region = appRegion } = action.payload;
    const { data } = yield call(apiFetchRegionDeliveryInfo, region);

    yield put(fetchRegionDeliveryInfoSuccess(data));
  } catch (err) {
    yield put(fetchRegionDeliveryInfoFailure(err.message));
  }
}

export function* fetchUserLatestDeliveryInfoFlow() {
  try {
    const { data } = yield call(apiFetchUserLatestDeliveryInfo);

    yield put(fetchUserLatestDeliveryInfoSuccess(data));
  } catch (err) {
    yield put(fetchUserLatestDeliveryInfoFailure(err.message));
  }
}

export default function*() {
  yield all([
    takeLatest(FETCH_REGION_DELIVERY_INFO, fetchRegionDeliveryInfoFlow),
    takeLatest(
      FETCH_USER_LATEST_DELIVERY_INFO,
      fetchUserLatestDeliveryInfoFlow
    ),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/purchase/deliveryInfo.js